// extracted by mini-css-extract-plugin
module.exports = {"container":"checkbox_container__3EBov","input":"checkbox_input__2msRa","checkmark":"checkbox_checkmark__pzr4a","label":"checkbox_label__3XuI1"};